// Animated temperature/spec counters for the homepage trust bar.
// Progressive enhancement: the final value is already in the DOM, so with JS
// disabled or reduced-motion on, the correct number just shows. When the strip
// scrolls into view, each .lw-count animates from data-from to data-to.
(function () {
  var counts = document.querySelectorAll('.lw-count');
  if (!counts.length) return;

  if (
    !('IntersectionObserver' in window) ||
    matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return; // leave the final values as rendered
  }

  var DURATION = 1500;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animate(el) {
    var from = parseFloat(el.getAttribute('data-from'));
    var to = parseFloat(el.getAttribute('data-to'));
    if (isNaN(from) || isNaN(to)) return;

    var start = null;
    // Match the DOM's final formatting (no decimals here, all integers).
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / DURATION, 1);
      var value = from + (to - from) * easeOutCubic(p);
      el.textContent = Math.round(value);
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = to; // exact final value
    }
    // Start visibly from the "from" value.
    el.textContent = Math.round(from);
    requestAnimationFrame(frame);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.querySelectorAll('.lw-count').forEach(animate);
        io.unobserve(e.target);
      });
    },
    { threshold: 0.4 }
  );

  var strip = document.querySelector('.lw-trust');
  if (strip) io.observe(strip);
})();
